//import { ClassNames } from "@emotion/react";
import { Divider } from "@mui/material";
import DraggableList from "../../DraggableList/DraggableList";
import classes from "../CustomInputs.module.css";

const DraggableListInput = (props) => {
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };
  

  const onDragEnd = ({ destination, source }) => {
    // dropped outside the list
    if (!destination) return;

    const newItems = reorder(props.items, source.index, destination.index);

    props.onChange({ [props.id]: newItems });
  };
  return (
    <div className={classes.customTextField}>
      <div className={classes.textField}>
        <Divider />
        <div className={classes.draggableList}>
          <DraggableList 
            items={props.items} 
            onDragEnd={onDragEnd} 
            handleDeleteRate={props.handleDeleteRate}
            currency={props.currency}
          />
        </div>
      </div>
    </div>
  );
};

export default DraggableListInput;
